import Notification from './notification';
const prefixCls = 'ivu-notice';
const iconPrefixCls = 'ivu-icon';
const prefixKey = 'ivu_notice_key_';
let style = {};
let bubble_Tips_style = {};
let top = 24;
let defaultDuration = 4.5;
let noticeInstanceMoveLeft, noticeInstanceMoveRight;
let name = 1;
const iconTypes = {
	'info': 'ios-information-circle',
	'success': 'ios-checkmark-circle',
	'warning': 'ios-alert',
	'error': 'ios-close-circle'
};

function getNoticeInstance(type) {
	if (type == 'rightToleft') {
		noticeInstanceMoveLeft = noticeInstanceMoveLeft || Notification.newInstance({
			prefixCls: prefixCls,
			styles: style,
			status: 1

		});
		return noticeInstanceMoveLeft;
	} else {
		noticeInstanceMoveRight = noticeInstanceMoveRight || Notification.newInstance({
			prefixCls: prefixCls,
			styles: style,
			status: 0
		});
		return noticeInstanceMoveRight;
	}
}

function notice(type, options) {
	const title = options.title || '';
	const desc = options.desc || '';
	const closeReminder = options.closeReminder || '';
	const moveOption = !options.moveType ? 'move-left' : options.moveType == 'rightToleft' ? 'move-right' : 'move-left';
	const noticeKey = options.name || `${prefixKey}${name}`;
	const onClose = options.onClose || function() {};
	const onClick = options.onClick || function() {};
	const onMounted = options.onMounted || function(name) {};
	const render = options.render;
	style = !options.moveType ? {
		left: 0
	} : options.moveType == 'rightToleft' ? {
		right: 0,
		top: '170px'
	} : {
		left: 0,
		bottom: '45px'
	};
	// bubble_Tips_style = !options.moveType ? {float:'left',borderRadius:'0px 20px 20px 0px'}: options.moveType=='rightToleft' ? {float:'right',borderRadius:'20px 0px 0px 20px'} : {float:'left',borderRadius:'0px 20px 20px 0px'}
	const duration = (options.duration === 0) ? 0 : options.duration || defaultDuration;
	name++;
	let instance = getNoticeInstance(options.moveType);
	let content;
	let withIcon;
	const with_desc = (options.render && !title) ? '' : (desc || options.render) ? ` ${prefixCls}-with-desc` : '';
	instance.notice({
		name: noticeKey.toString(),
		duration: duration,
		styles: {},
		transitionName: moveOption,
		moveType: options.moveType,
		tipsType: options.tipsType,
		bubbleType: options.bubbleType,
		icon: options.icon,
		content: content,
		withIcon: withIcon,
		render: render,
		hasTitle: !!title,
		title: options.title,
		locale: options.locale ? options.locale : '',
		closeReminder: closeReminder,
		volume: options.volume ? options.volume : undefined,
		ptid: options.ptid ? options.ptid : undefined,
		action: options.action,
		onClose: onClose,
		closable: true,
		type: 'notice',
		onClick: onClick,
		onMounted: onMounted
	});
}

export default {
	open(options) {
		return notice('normal', options);
	},
	info(options) {
		return notice('info', options);
	},
	success(options) {
		return notice('success', options);
	},
	warning(options) {
		return notice('warning', options);
	},
	error(options) {
		return notice('error', options);
	},
	config(options) {
		if (options.top) {
			top = options.top;
		}
		if (options.duration || options.duration === 0) {
			defaultDuration = options.duration;
		}
	},
	close(name) {
		if (name) {
			name = name.toString();
			if (noticeInstanceMoveLeft) {
				noticeInstanceMoveLeft.remove(name);
			}
		} else {
			return false;
		}
	},
	changeTitle(name, title) {
		if (name) {
			name = name.toString();
			if (noticeInstanceMoveLeft) {
				noticeInstanceMoveLeft.changeTitle(name, title);
			}
		} else {
			return false;
		}
	},
	getLength() {
		if (noticeInstanceMoveLeft) {
			return noticeInstanceMoveLeft.getLength()
		} else {
			return 0
		}
	},
	removeAllSpeaking(action) {
		if (noticeInstanceMoveLeft) {
			noticeInstanceMoveLeft.removeAllSpeaking(action)
		}
	},
	removeSpeaking(list) {
		if (noticeInstanceMoveLeft) {
			noticeInstanceMoveLeft.removeSpeaking(list)
		}
	},
	findChangeBubble(ptid, Volume) {
		if (noticeInstanceMoveLeft) {
			return noticeInstanceMoveLeft.findChangeBubble(ptid, Volume)
		}
	},
	removeExitSpeaking(ptid) {
		if (noticeInstanceMoveLeft) {
			return noticeInstanceMoveLeft.removeExitSpeaking(ptid)
		}
	},
	destroy() {
		this.destroyMoveRightBubble();
		this.destroyMoveLeftBubble();
	},
	destroyMoveRightBubble() {
		if (noticeInstanceMoveRight) {
			noticeInstanceMoveRight.destroy(`${prefixCls}_0`);
			noticeInstanceMoveRight = null
		}
	},
	destroyMoveLeftBubble() {
		if (noticeInstanceMoveLeft) {
			noticeInstanceMoveLeft.destroy(`${prefixCls}_0`);
			noticeInstanceMoveLeft = null
		}
	},
	hideRightBubble() {
		if (noticeInstanceMoveLeft) {
			document.getElementsByClassName(`${prefixCls}_1`)[0].style.display = 'none';
		}
	},
	showRightBubble() {
		if (noticeInstanceMoveLeft) {
			document.getElementsByClassName(`${prefixCls}_1`)[0].style.display = 'block'
		}
	}
};
